export const ResultStore = {
  img: '',
  title: '',
  product_id: '',
  organization_id: '',
  oname: '',
  donor_name: '',
  donor_email: '',
  donor_phone: '',
  amount: '',
  listid: '',
  state: '',
  transaction_id: '',
  pay_time: '',
  isNineProj: false,
};
